import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { topRightToast } from "../Shadcn/Sonner";
import { GeoId } from "../../types/geo.types";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useMap } from "@vis.gl/react-google-maps";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import equal from 'fast-deep-equal';
import { LuArrowUpRight } from "react-icons/lu";
import { useQuery } from "@tanstack/react-query";
import { useMapsService } from "../../services";
import { brandList, checkboxState, cifTypeState, choroplethModeState, collisionRadiusKmState, errorState, filterDefaultState, filterLoadingState, filtersState, focusedPoiState, geoJsonState, geoState, hexLoadingState, hoveredBrandState, loggedUserState, markerCarouselState, metricState, poiMapColorState, recommendedRegionsState, selectedBrands, selectedCategoricalLayerState, selectedTabState, selAggLayerState, selPOICategories, shimmerLiteState, showDrawerState, showMapColorState, spinnerState, userCurrencyState, dynamicTogglesState, dynamicPoiTogglesState } from "../../states";
import { checkIsBrandSelected, processGeoJSONGeometry, useHandleError, getParentGeoId, getRoIBoundsUsingPosition, checkOutOfBoundsUsingPosition, cleanFilterTree, getCurrGeoLevelName, getRoIBounds, normalizeLatLng, useMapZoomControls, getCollidingMarkers, getCollisionRadiusKm, getFirstCoordinate, latLngToPixel, removeParentFeature } from "../../helpers";
import { useStreetView } from "../../helpers/streetviewHook";
import { MapLayers, DeckGLOverlay, GeoHoverCard, MBPHoverPopup, POIHoverPopup, FeaturedStoriesWindows, ResetZoomButton, MapHelperNotification, AggUnitControl } from ".";
import { flattenMarkerData } from "./markerUtils";
import { Button, ButtonTheme, ButtonVariant, SpinnerLite, MapLayout } from "../../ui-elements";
import { HexLoadingToast, HexUnavailableToast } from "../Shadcn";
import { DISTRICT_BOUNDARY_BG_STYLE, DISTRICT_BOUNDARY_STYLE, RESET_FIELD_ARRAY, ROI_RECTANGLE_SPEC, RouteConstants } from "../../constants";

interface MapContainerProps {
    spinnerLite: number;
    myPresence?: any[];
    stories?: any[];
    selectedStory?: any;
    isStreetViewEnabled?: boolean;
    toggleSwitch?: (e: any, name: any, value: boolean) => void;
    setMapSpinner: React.Dispatch<React.SetStateAction<number>>;
    setIsStreetViewEnabled?: (flag: boolean) => void;
    showHelperText?: boolean;
    setShowHelperText?: React.Dispatch<React.SetStateAction<boolean>>;
    setMapColorShimmer?: React.Dispatch<React.SetStateAction<boolean>>;
    mbpFilter?: any;
    selCatchmentType?: any;
    catchment?: any;
    tableClickedPoi?: any;
    setTableClickedPoi?: React.Dispatch<React.SetStateAction<any>>;
    tableClickedMbp?: any;
    setTableClickedMbp?: React.Dispatch<React.SetStateAction<any>>;
    carouselHandlersRef?: React.MutableRefObject<{
        onMarkerSelect?: (marker: { type: string; data: any }) => void;
        onClose?: () => void;
    }>;
}

export const DeckGLMapContainer: React.FC<MapContainerProps> = ({
    spinnerLite,
    myPresence,
    stories,
    selectedStory,
    isStreetViewEnabled,
    toggleSwitch,
    setMapSpinner,
    setIsStreetViewEnabled,
    showHelperText,
    setShowHelperText,
    setMapColorShimmer,
    mbpFilter,
    selCatchmentType,
    catchment,
    tableClickedPoi,
    setTableClickedPoi,
    tableClickedMbp,
    setTableClickedMbp,
    carouselHandlersRef,
}) => {
    const COUNTRY_MAP_ID = process.env.REACT_APP_MAP_ID;
    const SILVER_MAP_ID = process.env.REACT_APP_MAP_ID_1;
    const MAP_TYPE_ID = process.env.REACT_APP_MAP_TYPE_ID;
    const map = useMap();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const mapService = useMapsService();
    const [selectedGeo, setselectedGeo] = useRecoilState(geoState);
    const cifType = useRecoilValue(cifTypeState);
    const loggedUser = useRecoilValue(loggedUserState);
    const isChecked = useRecoilValue(checkboxState);
    const geoJSON = useRecoilValue(geoJsonState);
    const setGeoJSON = useSetRecoilState(geoJsonState);
    const poiColors = useRecoilValue(poiMapColorState);
    const selCategoryList = useRecoilValue(selPOICategories);
    const selCurrency = useRecoilValue(userCurrencyState);
    const showMapColor = useRecoilValue(showMapColorState);
    const dynamicToggles = useRecoilValue(dynamicTogglesState);
    const dynamicPoiToggles = useRecoilValue(dynamicPoiTogglesState);
    const choroplethMode = useRecoilValue(choroplethModeState);
    const selectedCategoricalLayer = useRecoilValue(selectedCategoricalLayerState);
    const [hoverData, setHoverData] = useState<any>();
    const [featuredStories, setFeaturedStories] = useState<any[]>([]);
    const [center, setCenter] = useState({ lat: 20.5937, lng: 78.9629 });
    const [focused, setFocused] = useState(0);
    const [hoveredBrand, setHoveredBrand] = useRecoilState<any>(hoveredBrandState);
    const [openedStories, setOpenedStories] = useState<number[]>([]);
    const { getErrorMsg } = useHandleError();
    const { handleZoomOutStyle, handleWheel, handleTouch, handleDragEnd, handleResetBound } = useMapZoomControls();

    useStreetView(map, setIsStreetViewEnabled);

    const [spinner, setSpinner] = useRecoilState(spinnerState);
    const [shimmerLite, setShimmerLite] = useRecoilState(shimmerLiteState);
    const [mapProps, setMapProps] = useState<any>();
    const [mapType, setMapType] = useState<'roadmap' | 'hybrid' | 'map' | 'dark'>(localStorage.getItem("map-style") as 'roadmap' | 'hybrid' | 'map' | 'dark' || 'roadmap');
    const [subDistrictDefaultMapInfo, setSubDistrictDefaultMapInfo] = useState<{ bounds: any, zoom: number }>({ bounds: null, zoom: 1 });
    const [brands, setBrands] = useRecoilState(brandList);
    const [selBrands, setSelBrands] = useRecoilState(selectedBrands);
    const [hoveredPresence, setHoveredPresence] = useState<any | null>(null);
    const [zoom, setZoom] = useState({ isZoomed: false, zoomLevel: 0, center: map?.getCenter() ?? { lat: 20.5937, lng: 78.9629 } });
    const [focusedPoi, setFocusedPoi] = useRecoilState(focusedPoiState);
    const focusedPoiRef = useRef(focusedPoi);
    const selMetric = useRecoilValue(metricState);
    const setError = useSetRecoilState(errorState);
    const filters = useRecoilValue<any[]>(filtersState);
    const filtersdefaults = useRecoilValue<any[]>(filterDefaultState);
    const [selectedTab, setSelectedTab] = useRecoilState(selectedTabState);
    const districtBoundariesRef = useRef<google.maps.Polyline[]>([]);
    const roiBoundsRef = useRef<{ top: number; bottom: number; left: number; right: number; width: number; height: number; } | null>(null);
    const outOfBoundSideRef = useRef<string[]>([]);
    const isFilterLoading = useRecoilValue(filterLoadingState);
    // const poiBoundRef = useRef<{ top: number; bottom: number; left: number; right: number; width: number; height: number; } | null>(null);
    // const mbpBoundRef = useRef<{ top: number; bottom: number; left: number; right: number; width: number; height: number; } | null>(null);
    const poiBoundRef = useRef<{ north: number; south: number; east: number; west: number; } | null>(null);
    const mbpBoundRef = useRef<{ north: number; south: number; east: number; west: number; } | null>(null);
    const setRecommendedRegionsPayload = useSetRecoilState(recommendedRegionsState);
    const isHoveredOnMarker = useRef<{ poi: boolean, mbp: boolean }>({ poi: false, mbp: false })
    const isGeoFocusedRef = useRef<boolean>(false);
    const [focusedGeo, setFocusedGeo] = useState<any>(false);
    const [open, setOpen] = useRecoilState(showDrawerState);
    const selAggLayer = useRecoilValue(selAggLayerState);

    const mapPropsPayloadRef = useRef<any>(null);
    const mapPropsRef = useRef<any>(null);
    const prePanCenterRef = useRef<google.maps.LatLng | null>(null);

    // State for tracking hex and non-hex data loading
    const [hexLoading, setHexLoading] = useRecoilState(hexLoadingState);
    const [showHexToast, setShowHexToast] = useState(false);
    const [showHexUnavailableToast, setShowHexUnavailableToast] = useState(false);
    const [showCategoricalToast, setShowCategoricalToast] = useState(false);
    const isHexAvailable = poiColors?.rootProperties?.isHexAvailable !== false;
    const prevIsHexAvailableRef = useRef<boolean | null>(null);

    const [boundaryLoadingState, setBoundaryLoadingState] = useState<{
        loading: boolean;
        firstChunkReceived: boolean;
    }>({ loading: false, firstChunkReceived: false });

    // Refs to accumulate features from both hex and non-hex queries
    const accumulatedFeaturesRef = useRef<{
        rootProperties: any;
        hexFeatures: any[];
        nonHexFeatures: any[];
    }>({ rootProperties: null, hexFeatures: [], nonHexFeatures: [] });

    // Ref to track current aggregation layer for use in callbacks
    const selAggLayerRef = useRef(selAggLayer);
    useEffect(() => {
        selAggLayerRef.current = selAggLayer;
    }, [selAggLayer]);

    // Combined carousel state for MBPs, POIs, and regions — shared via Recoil so Home.tsx can render CollisionTablePanel
    const [markerCarousel, setMarkerCarousel] = useRecoilState(markerCarouselState);
    const setCollisionRadiusKm = useSetRecoilState(collisionRadiusKmState);

    // Tracks current map zoom so collisionRadiusKm stays in sync after zoom changes
    const [mapZoom, setMapZoom] = useState<number>(map?.getZoom() ?? 1);

    // Clear stale boundaries on mount so key-based remount (catchment toggle) always starts fresh
    useEffect(() => {
        setGeoJSON({ type: 'FeatureCollection', rootProperties: null, features: [] } as any);
    }, []);

    useEffect(() => {
        if (!map) return;
        const listener = map.addListener('zoom_changed', () => {
            setMapZoom(map.getZoom() ?? 1);
        });
        return () => listener.remove();
    }, [map]);

    // Sync collisionRadiusKm to Recoil whenever carousel or zoom changes so Home.tsx can pass it to CollisionTablePanel.
    useEffect(() => {
        if (!markerCarousel?.markers.length) { setCollisionRadiusKm(null); return; }
        const ref = markerCarousel.markers.find(m => m.type !== 'region');
        if (!ref) { setCollisionRadiusKm(null); return; }
        const pixelRadius = ref.type === 'mbp' ? 27.17 : 5;
        setCollisionRadiusKm(getCollisionRadiusKm(map, ref.data.latitude, pixelRadius));
    }, [markerCarousel, mapZoom, map]);

    // Carousel state for GeoJSON features
    const [geoCarousel, setGeoCarousel] = useState<{
        features: any[];
        currentIndex: number;
    } | null>(null);

    const geoCode = useMemo(() => {
        const { country, state, district, sub_district, village } = selectedGeo;
        const geo_id = village || sub_district || district || state || country;
        return geo_id === '1' ? 'EW-IN-IND-22-0' : geo_id;
    }, [selectedGeo]);

    const uniqueStories = Array.from(
        new globalThis.Map(
            stories?.map(story => [JSON.stringify(story.geometry.coordinates), story])
        ).values()
    );

    //fetch featured stories
    const fetchFeaturedStories = (geoCode: GeoId) => {
        //setSpinner(prev => ({ ...prev, count: prev.count + 1 }));
        mapService.getFeaturedStories(geoCode, selCurrency).then((response: { featuredStories: any; }) => {
            setFeaturedStories(response.featuredStories || []);
        }).catch((error: any) => {
            getErrorMsg(error);
        })
        // .finally(() => setSpinner(prev => ({ ...prev, count: prev.count - 1 })));
    }

    //fetch map props
    const fetchMapProps = (payload: any) => {
        // setMapSpinner(prev => prev + 1);
        mapService.getMapProperties(payload).then((response: any) => {
            setMapProps(response);
        }).catch((error: any) => {
            getErrorMsg(error);
        })
        // .finally(() => setMapSpinner(prev => prev - 1));
    }

    useEffect(() => {
        mapPropsRef.current = mapProps;
    }, [mapProps]);

    // toggle spotlights switch if all the spotlights have closed
    const handleCloseMapPopup = (index: number) => {
        if (toggleSwitch) {
            const opened = openedStories.filter(item => item !== index);
            if (opened.length === 0) {
                toggleSwitch(null, 'stories', false);
            }
            setOpenedStories(opened);
        }
    }

    const handleFocused = (index: number) => {
        setFocused(index);
    };

    const handleMapType = (type: 'roadmap' | 'hybrid' | 'map' | 'dark') => {
        setMapType(type);
        localStorage.setItem("map-style", type);
    }

    const onMouseOver = (x: number, y: number, object: any, selectedTab: number) => {
        if (!mapPropsRef.current || !mapPropsRef.current.properties) return;

        // Handle mouse leaving the feature
        if (!object) {
            if (!isGeoFocusedRef.current) setHoverData(null);
            return;
        }

        // Handle both old structure (geoLevel) and new structure (geoValue)
        const geoLevel = object.geoValue || object.geoLevel;

        if (selectedGeo.state && ((hoveredPresence || hoveredBrand) && !isGeoFocusedRef.current)) {
            setHoverData(null);
            return;
        }

        if (!isGeoFocusedRef.current) outOfBoundSideRef.current = checkOutOfBoundsUsingPosition({ x, y }, roiBoundsRef.current);

        if (geoCode == selectedGeo.district && ((selectedTab === 5 && geoLevel === 'sub_district') || selectedTab === 4 && geoLevel === 'pincode')) return;

        onHoverMap(object, selectedTab, { x, y });
    }

    //display the geo info popup on hover over the geojson item
    const onHoverMap = (feature: any, selectedTab: number, coordinates: { x: number, y: number }) => {
        // If card is focused (clicked), don't update hover data at all
        if (isGeoFocusedRef.current) return;

        // Handle both old structure (geoId) and new structure (hexGeoId)
        let { geoId, parent_id, hexGeoId } = feature;

        // Use hexGeoId if it exists, otherwise use geoId
        const actualGeoId = hexGeoId || geoId;

        if (geoCode === (selectedGeo.country)) geoId = parent_id;

        const found: any = mapPropsRef.current?.properties?.find((item: any) => item.geoId === actualGeoId || item.hexGeoId === actualGeoId);
        if (found) {
            setHoverData((prev: any) => {
                if ((prev?.geoId === actualGeoId) || (prev?.hexGeoId === actualGeoId)) {
                    return { ...prev, ...coordinates };
                }
                return { ...found, ...coordinates };
            });
        } else {
            setHoverData(null);
        }
    };

    const onMouseOut = useCallback((event: any, map: google.maps.Map) => {
        map?.data.revertStyle(event.feature);
        // if (!isGeoFocusedRef.current) setHoverData(null);
    }, [mapProps]);

    //navigate to the clicked geo
    const onGeoClick = (geoId: GeoId, geoLevel: string, coordinates: { x: number, y: number }, data: any) => {
        if(geoLevel=="hex") return
        if (geoLevel === 'catchment') {
            // Handle both old structure (geoId) and new structure (hexGeoId)
            const found: any = mapPropsRef.current?.properties?.find((item: any) => item.geoId === geoId || item.hexGeoId === geoId);
            handlePoiClick('mbp', found, [coordinates?.x!, coordinates?.y!]);
        }

        if (isHoveredOnMarker?.current?.mbp && !!selectedGeo?.state) return;

        if ((geoLevel === 'pincode' && selectedTab === 4)) return;

        if (geoLevel === 'pincode') geoLevel = 'sub_district';

        if (!selectedGeo.state) {
            const resetFields: any = {
                country: { state: '', district: '', sub_district: '', village: '' },
                state: { district: '', sub_district: '', village: '' },
                district: { sub_district: '', village: '' },
                sub_district: { village: '' }
            };
            const updatedGeo = {
                ...selectedGeo,
                [geoLevel]: geoId,
                ...(resetFields[geoLevel] || {}),
            }

            setselectedGeo(updatedGeo);
            return;
        }

        // Close any open presence/poi card before opening region card
        if (focusedPoi?.type && geoLevel !== 'catchment') {
            setFocusedPoi({ type: null, data: null });
            setHoveredPresence(null);
            setHoveredBrand(null);
            isHoveredOnMarker.current.mbp = false;
            isHoveredOnMarker.current.poi = false;
        }

        // Temporarily reset focus to allow hover data update
        isGeoFocusedRef.current = false;

        // Update hover data for the new region
        if (coordinates) {
            outOfBoundSideRef.current = checkOutOfBoundsUsingPosition(coordinates, roiBoundsRef.current);
            onHoverMap({ geoId, geoLevel }, selectedTab, coordinates);
        }

        // No carousel on direct region click — clear both carousel states
        setMarkerCarousel(null);
        setGeoCarousel(null);

        // Set focus back to true after updating
        setFocusedGeo(true);
        isGeoFocusedRef.current = true;
    }

    // Ray-casting point-in-polygon for GeoJSON geometries (coordinates in [lng, lat] format)
    const pointInPolygon = (lng: number, lat: number, geometry: any): boolean => {
        const isInRing = (ring: [number, number][]): boolean => {
            let inside = false;
            for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
                const [xi, yi] = ring[i];
                const [xj, yj] = ring[j];
                if (((yi > lat) !== (yj > lat)) && (lng < (xj - xi) * (lat - yi) / (yj - yi) + xi)) {
                    inside = !inside;
                }
            }
            return inside;
        };
        try {
            if (geometry.type === 'Polygon') return isInRing(geometry.coordinates[0]);
            if (geometry.type === 'MultiPolygon') return geometry.coordinates.some((poly: any) => isInRing(poly[0]));
        } catch (e) {}
        return false;
    };

    const handleCloseRegionCard = () => {
        isGeoFocusedRef.current = false;
        setFocusedGeo(false);
        setHoverData(null);
        setGeoCarousel(null);
        setMarkerCarousel(null);
         if (prePanCenterRef.current && map) {
                map.panTo(prePanCenterRef.current);
                prePanCenterRef.current = null;
            }
              if (map) {
                google.maps.event.addListenerOnce(map, 'idle', () => onPanChange(map));
            }
    }

    // Set up click functionality for zoom buttons
    useEffect(() => {
        const zoomOutButton: any = document.querySelector('button[title="Zoom out"]');
        const zoomInButton: any = document.querySelector('button[title="Zoom in"]');
        const pegmanButton: any = document.querySelector('button[title="Drag Pegman onto the map to open Street View"]');

        const handleZoomClick = () => {
            handleCloseRegionCard();
        };

        const handlePegmanMouseDown = () => {
            handleCloseRegionCard();
        };

        if (zoomOutButton && zoomInButton) {
            zoomOutButton.addEventListener('click', handleZoomClick, true);
            zoomInButton.addEventListener('click', handleZoomClick, true);
            pegmanButton?.addEventListener('mousedown', handlePegmanMouseDown, true);
        }

        // Cleanup function to remove event listener when component unmounts
        return () => {
            if (zoomOutButton && zoomInButton) {
                zoomOutButton.removeEventListener('click', handleZoomClick, true);
                zoomInButton.removeEventListener('click', handleZoomClick, true);
                pegmanButton?.removeEventListener('mousedown', handlePegmanMouseDown, true);
            }
        };
    }, [map?.getBounds()]);

    // Handle WebGL context loss and restoration
    useEffect(() => {
        const canvas = map?.getDiv()?.querySelector('canvas');

        const handleContextLost = (event: Event) => {
            event.preventDefault();
            console.warn('WebGL context lost - preventing default behavior');
        };

        const handleContextRestored = () => {
            // Force re-render of deck.gl layers by updating mapProps
            if (mapProps) {
                setMapProps({ ...mapProps });
            }
        };

        if (canvas) {
            canvas.addEventListener('webglcontextlost', handleContextLost);
            canvas.addEventListener('webglcontextrestored', handleContextRestored);
        }

        return () => {
            if (canvas) {
                canvas.removeEventListener('webglcontextlost', handleContextLost);
                canvas.removeEventListener('webglcontextrestored', handleContextRestored);
            }
        };
    }, [map, mapProps]);

    const onPanChange = (map: google.maps.Map | null) => {
        if (map) {
            // poiBoundRef.current = getRoIBoundsUsingPosition(map, ROI_RECTANGLE_SPEC.POI);
            // mbpBoundRef.current = getRoIBoundsUsingPosition(map, ROI_RECTANGLE_SPEC.MBP);
            poiBoundRef.current = getRoIBounds(map, ROI_RECTANGLE_SPEC.POI);
            mbpBoundRef.current = getRoIBounds(map, ROI_RECTANGLE_SPEC.MBP);
        }
    };

    const handleNavigation = (e: any, resetFields: any, navigation: any, geoLevel: string) => {
        e.stopPropagation();
        handleCloseRegionCard();
        setFocusedPoi({ type: null, data: null });
        setHoveredBrand(null);
        setHoveredPresence(null);

        if (geoLevel === 'catchment') {
            searchParams.set('catchment', navigation?.catchment);
            navigate({
                pathname: RouteConstants.catchments,
                search: `?${searchParams.toString()}`,
            });
            return;
        }

        const selGeo: Record<string, any> = {};

        resetFields.forEach((key: string) => {
            if (key === 'pincode' || key === 'sub_district')
                key = selectedTab === 4 ? 'sub_district' : 'pincode';
            let value = navigation[key];

            if (value !== undefined && value !== null && value !== "") {
                if (key === 'pincode') selGeo['sub_district'] = value;
                else selGeo[key] = value;
            }
        });

        setselectedGeo(selGeo);
    }

    const handleNavigationFromRegionCard = (e: any, navigation: any) => {
        e.stopPropagation();
        handleCloseRegionCard();
        setFocusedPoi({ type: null, data: null });
        setHoveredBrand(null);
        setHoveredPresence(null);

        const selGeo: Record<string, any> = {};

        RESET_FIELD_ARRAY['all'].forEach((key: string) => {
            let value = navigation[key];

            if (value !== undefined && value !== null && value !== "") {
                if (key === 'pincode') selGeo['sub_district'] = value;
                else selGeo[key] = value;
            }
        });
        setselectedGeo(selGeo);
    }

    const getPayload = (geoId: GeoId) => {

        return {
            geoId,
            type: cifType,
            currency: selCurrency,
            ...selCategoryList,
        }
    }

    //fetch featured stories and map properties
    useEffect(() => {
        if (selectedGeo && loggedUser.company && pathname === RouteConstants.root) {
            fetchFeaturedStories(geoCode);
        }
    }, [selectedGeo, loggedUser.company, selCurrency]);


    // Helper function to merge features and update geoJSON state
    const mergeAndUpdateGeoJSON = () => {
        const { rootProperties, hexFeatures, nonHexFeatures } = accumulatedFeaturesRef.current;

        // Filter features based on selected aggregation layer (use ref to get latest value)
        let features: any[] = [];

        if (selAggLayerRef.current?.key === 'hexgrid') {
            // Show hex features only when hex grid is selected
            features = [...nonHexFeatures, ...hexFeatures];
        } else {
            // Show only non-hex features (sub-region boundaries)
            features = [...nonHexFeatures];
        }

        const newGeoJSON = {
            type: 'FeatureCollection',
            rootProperties,
            features
        };

        setGeoJSON(newGeoJSON);
    };

    // Determine if we should fetch hex data (only at district level)
    const shouldFetchHex = !!selectedGeo?.district;

    // Query for non-hex boundaries (lighter data, loads quickly)
    const { isLoading: isBoundaryLoading } = useQuery({
        queryKey: ['mapBoundaries', geoCode, isChecked?.catchments ? selCatchmentType?.key : null, isChecked?.adjacency],
        queryFn: async ({ signal }) => {
            if (!geoCode) return null;

            // Reset accumulated features for non-hex
            accumulatedFeaturesRef.current.nonHexFeatures = [];
            setBoundaryLoadingState({ loading: true, firstChunkReceived: false });

            // Show hex toast immediately when boundary query starts (if hex will be fetched)
            if (shouldFetchHex) {
                setShowHexToast(true);
                setHexLoading({ loading: true, firstChunkReceived: false, progress: 0 });
            }

            return mapService.getMap(
                (geoCode),
                false, // hex=false
                isChecked?.catchments ? selCatchmentType?.key : null,
                isChecked?.adjacency,
                signal,
                (progressData) => {
                    // Handle progress updates
                    if (progressData.type === 'rootProperties') {
                        accumulatedFeaturesRef.current.rootProperties = progressData.data;
                        mergeAndUpdateGeoJSON();
                    } else if (progressData.features) {
                        accumulatedFeaturesRef.current.nonHexFeatures = [
                            ...accumulatedFeaturesRef.current.nonHexFeatures,
                            ...progressData.features
                        ];

                        // Mark first chunk as received
                        if (!boundaryLoadingState.firstChunkReceived) {
                            setBoundaryLoadingState({ loading: true, firstChunkReceived: true });
                        }

                        mergeAndUpdateGeoJSON();
                    } else if (progressData.status === 'complete') {
                        setBoundaryLoadingState({ loading: false, firstChunkReceived: true });
                    }
                }
            );
        },
        enabled: !!selectedGeo && !!selCurrency && !!geoCode,
        staleTime: 0,
        gcTime: 0,
    });

    // Query for hex data (heavy data, loads progressively) - only at district level
    const { isLoading: isHexLoading } = useQuery({
        queryKey: ['mapHexData', geoCode, isChecked?.catchments ? selCatchmentType?.key : null, isChecked?.adjacency],
        queryFn: async ({ signal }) => {
            if (!geoCode || !shouldFetchHex) return null;

            // Reset accumulated features for hex
            accumulatedFeaturesRef.current.hexFeatures = [];

            return mapService.getMap(
                (geoCode),
                true, // hex=true
                isChecked?.catchments ? selCatchmentType?.key : null,
                isChecked?.adjacency,
                signal,
                (progressData) => {
                    // Handle progress updates
                    if (progressData.status === 'started') {
                        setShowHexToast(true);
                        setHexLoading(prev => ({ ...prev, loading: true }));
                    } else if (progressData.features) {
                        accumulatedFeaturesRef.current.hexFeatures = [
                            ...accumulatedFeaturesRef.current.hexFeatures,
                            ...progressData.features
                        ];

                        // Mark first chunk as received (switch from loader to progress indicator)
                        if (!hexLoading.firstChunkReceived) {
                            setHexLoading(prev => ({ ...prev, firstChunkReceived: true }));
                        }

                        // Update progress (rough estimate based on feature count)
                        const estimatedProgress = Math.min(95, (progressData.totalFeatures / 1000) * 100);
                        setHexLoading(prev => ({ ...prev, progress: estimatedProgress }));

                        mergeAndUpdateGeoJSON();
                    } else if (progressData.status === 'complete') {
                        setHexLoading({ loading: false, firstChunkReceived: true, progress: 100 });
                        setTimeout(() => setShowHexToast(false), 2000);
                    }
                }
            );
        },
        enabled: !!selectedGeo && !!selCurrency && !!geoCode && shouldFetchHex,
        staleTime: 0,
        gcTime: 0,
    });

    // Reset accumulated features when geoCode changes
    useEffect(() => {
        accumulatedFeaturesRef.current = {
            rootProperties: null,
            hexFeatures: [],
            nonHexFeatures: []
        };
        setHexLoading({ loading: false, firstChunkReceived: false, progress: 0 });
        setBoundaryLoadingState({ loading: false, firstChunkReceived: false });
        setShowHexToast(false);
    }, [geoCode]);


    // Update displayed features when aggregation layer changes (without refetching)
    // This allows instant switching between hex and non-hex views using already-loaded data
    useEffect(() => {
        // Only update if we have data already loaded
        if (accumulatedFeaturesRef.current.rootProperties) {
            mergeAndUpdateGeoJSON();
        }
    }, [selAggLayer?.key]);

    // Handle side effects when geo changes
    useEffect(() => {
        setZoom({ isZoomed: false, zoomLevel: map?.getZoom() || 0, center: normalizeLatLng(map?.getCenter()) });

        // Clear MBP/POI states when navigating between geo levels
        setHoveredPresence(null);
        setHoveredBrand(null);
        setFocusedPoi({ type: null, data: null });

        // Clear brands so sub-district POI data doesn't persist when navigating back to district.
        if(!selectedGeo?.sub_district) setBrands({});

        // Handle map options
        if (!selectedGeo.sub_district && map) {
            map.setOptions({
                gestureHandling: 'none',
                minZoom: undefined,
                draggable: false
            });
        } else if (selectedGeo.sub_district && map) {
            map.setOptions({
                gestureHandling: 'auto',
                draggable: true
            });
        }
        handleCloseRegionCard();
    }, [selectedGeo, isChecked?.adjacency, isChecked?.catchments, selCatchmentType]);


    useEffect(()=>{
        if(!isChecked?.poimarker)
            {
                handleCloseRegionCard();
                setHoveredPresence(null);
                setHoveredBrand(null);
                setFocusedPoi({ type: null, data: null });
                setMarkerCarousel(null);
            }
    },[isChecked?.poimarker])

    // Display geoJSON data in the map
    useEffect(() => {
        if (Object.keys(geoJSON).length && map) {
            // setHoverData(null);
            // map?.data.forEach((feature) => {
            //     map.data.remove(feature);
            // });

            // map?.data.addGeoJson(geoJSON);

            let onClickListener: google.maps.MapsEventListener | undefined;
            let onMouseOverListener: google.maps.MapsEventListener | undefined;
            let onMouseOutListener: google.maps.MapsEventListener | undefined;
            let boundsListener: google.maps.MapsEventListener | undefined;
            let zoomListener: google.maps.MapsEventListener | undefined;
            let dragListener: google.maps.MapsEventListener | undefined;
            let onPanChangeListener: google.maps.MapsEventListener | undefined;
            let wheelHandler: ((event: WheelEvent) => void) | undefined;
            let touchHandler: ((event: TouchEvent) => void) | undefined;

            // if (from === 'home' && !selectedGeo.village) {
            //     onMouseOverListener = map?.data.addListener('mousemove', (event: any) => onMouseOver(event, map, selectedTab));
            //     onMouseOutListener = map?.data.addListener('mouseout', (event: any) => onMouseOut(event, map));
            //     onClickListener = map?.data.addListener('click', onGeoClick);
            // }

            const processCoordinates = (coordinates: any): void => {
                if (Array.isArray(coordinates[0])) {
                    // Multi-part geometry, like a polygon with holes or a multi-line string
                    coordinates.forEach((coordSet: any) => {
                        processCoordinates(coordSet);
                    });
                } else {
                    // Single set of coordinates
                    bounds.extend(new window.google.maps.LatLng(coordinates[1], coordinates[0]));
                }
            };

            const bounds = new window.google.maps.LatLngBounds();
            geoJSON?.features.forEach((feature: any) => {
                if ((isChecked?.adjacency && feature?.properties?.geoLevel !== getCurrGeoLevelName(selectedGeo)) || !isChecked?.adjacency || selectedGeo?.village)
                    processCoordinates(feature.geometry.coordinates);
            });

            if (!selectedGeo.sub_district && map) {
                map.setOptions({
                    gestureHandling: 'none',
                    minZoom: undefined,
                    draggable: false
                });
            } else if (selectedGeo.sub_district && map) {
                map.setOptions({
                    gestureHandling: 'auto',
                    draggable: true
                });
            }
            // Set map center and zoom level based on bounding box
            map?.fitBounds(bounds, 20);

            setTimeout(() => {
                if (zoom.isZoomed && selectedGeo.sub_district && !selectedGeo.village) {
                    map?.setZoom(zoom.zoomLevel);
                    map?.setCenter(zoom.center);
                    if (zoom.zoomLevel <= subDistrictDefaultMapInfo.zoom - 1) {
                        map.setOptions({
                            gestureHandling: 'greedy',
                            minZoom: subDistrictDefaultMapInfo.zoom - 1,
                            draggable: false
                        });
                    }
                }
            }, 0);

            boundsListener = window.google.maps.event.addListenerOnce(map, "bounds_changed", () => {
                roiBoundsRef.current = getRoIBoundsUsingPosition(map, isChecked?.catchments ? ROI_RECTANGLE_SPEC.MBP : ROI_RECTANGLE_SPEC.HOVER);
                mbpBoundRef.current = getRoIBounds(map, ROI_RECTANGLE_SPEC.MBP);

                // if (pathname !== '/') {
                //     if (!selectedGeo.state) map.setZoom((map.getZoom()! || 0) + 0.625); //reduced zoom factor from 0.75 to 0.725 (TAR-750) //UPDATED - TAR-1087 - reduced to 0.625 only for country level
                //     else map.setZoom((map.getZoom()! || 0) + 0.4);
                // }

                if ((Number(selectedGeo.sub_district) === (geoJSON?.rootProperties?.geoId) || (selectedGeo.village) === (geoJSON?.rootProperties?.geoId) || catchment === (geoJSON?.rootProperties?.geoId))) {
                    const initialZoom = !zoom.isZoomed ? (map.getZoom()! || 0) : subDistrictDefaultMapInfo.zoom;

                    if (zoomListener) zoomListener.remove();

                    zoomListener = map?.addListener("zoom_changed", () => {
                        const zoomData = handleZoomOutStyle(initialZoom, map);
                        setZoom(zoomData);
                    });
                    onPanChangeListener = map?.addListener("idle", () => {
                        if (map) onPanChange(map);
                    });
                    dragListener = map?.addListener('dragend', () => {
                        const centerData = handleDragEnd(map);
                        if (centerData) {
                            setZoom(prev => ({
                                ...prev,
                                center: centerData
                            }));
                        }
                    });

                    if (!zoom.isZoomed) setSubDistrictDefaultMapInfo({ bounds, zoom: initialZoom });

                    wheelHandler = (event: WheelEvent) => {
                        const zoomData = handleWheel(event, map);
                        setZoom(zoomData);
                    };
                    touchHandler = (event: TouchEvent) => {
                        const zoomData = handleTouch(event, map, initialZoom);
                        setZoom(zoomData);
                    };

                    map.getDiv().addEventListener("wheel", wheelHandler, { passive: false });
                    map.getDiv().addEventListener("touchstart", touchHandler, { passive: false });
                }
            });

            setCenter({ lat: bounds?.getCenter()?.lat(), lng: bounds?.getCenter()?.lng() });

            // Cleanup function
            return () => {
                if (pathname === RouteConstants.root) {
                    onMouseOverListener?.remove();
                    onMouseOutListener?.remove();
                    onClickListener?.remove();
                    // mouseOver?.remove();

                    if (wheelHandler) map.getDiv().removeEventListener("wheel", wheelHandler);
                    if (touchHandler) map.getDiv().removeEventListener("touchstart", touchHandler);

                    if (zoomListener) zoomListener?.remove();
                    if (onPanChangeListener) onPanChangeListener?.remove();
                    if (dragListener) dragListener?.remove();
                }
                if (boundsListener) boundsListener.remove();
            };
        }
    }, [map, geoJSON, mapProps, selectedTab, geoCode, isChecked?.subregionBoundaries]);

    // Debounce the map color query key to batch rapid successive state changes
    // (e.g. selectedGeo and selAggLayer change in separate renders on geo navigation)
    const [debouncedMapColorKey, setDebouncedMapColorKey] = useState({
        geoCode, selCategoryList, selCurrency, selMetric, filtersdefaults,
        adjacency: isChecked?.adjacency, catchments: isChecked?.catchments,
        catchmentTypeKey: selCatchmentType?.key, selectedTab, selectedGeo, aggLayerKey: selAggLayer?.key,
        dynamicToggles,
    });
    useEffect(() => {
        const timer = setTimeout(() => setDebouncedMapColorKey({
            geoCode, selCategoryList, selCurrency, selMetric, filtersdefaults,
            adjacency: isChecked?.adjacency, catchments: isChecked?.catchments,
            catchmentTypeKey: selCatchmentType?.key, selectedTab, selectedGeo, aggLayerKey: selAggLayer?.key,
            dynamicToggles,
        }), 50);
        return () => clearTimeout(timer);
    }, [geoCode, selCategoryList, selCurrency, selMetric, filtersdefaults, isChecked?.adjacency, isChecked?.catchments, selCatchmentType?.key, selectedTab, selectedGeo, selAggLayer?.key, dynamicToggles]);

    //fetch poi map color
    const { isFetching: isMapColorFetching } = useQuery({
        queryKey: ['mapColor', debouncedMapColorKey],
        queryFn: async ({ signal }) => {
            const subLevel = (geoCode == selectedGeo.district && !selectedGeo.sub_district) ? selectedTab : null;
            const { category, subcategory } = selCategoryList;
            const oldfilters = JSON.parse(localStorage?.getItem("filters")!);

            if (!geoCode || category.length === 0 || subcategory.length === 0 || !selCurrency || (String(geoCode) === String(selectedGeo.village) && selAggLayer?.key !== 'hexgrid') || isFilterLoading || !(Array.isArray(oldfilters))) return null;

            const selMetrics = JSON.parse(localStorage?.getItem("selMetrics") || '{}');
            const metric_type = (!selMetrics || Object.values(selMetrics).filter((item: any) => !!item).length === 0)
                ? cifType.map(item => ({ key: item, ismetric: false }))
                : Object.values(selMetrics).map((metric: any) => {
                    const { title, ...rest } = metric || {};
                    return { ...rest };
                }) || [];

            const choroplethMetrics = Object.entries(dynamicToggles).map(([id, isOn]) => ({ key: id, ismetric: false, isRank: isOn }));
            const metric_type_final = [...metric_type, ...choroplethMetrics];

            const filters_new = filters.map(cleanFilterTree);
            if (!selectedGeo?.village && filters_new.length === 0) return null;

            const payload = {
                subcategory,
                metric_type: metric_type_final,
                filters: filters_new,
                currency: selCurrency,
                geoId: geoCode,
                adjacency: isChecked?.adjacency || false,
                catchment: isChecked?.catchments ? [selCatchmentType?.title] : [],
                hex: selectedGeo?.district ? selAggLayer?.key === 'hexgrid' : false,
                sublevel: subLevel,
                ...(choroplethMode === 'categorical' && selectedCategoricalLayer
                    ? { 'categorical_filter': selectedCategoricalLayer }
                    : {}),
            };

            if (String(geoCode) !== String(selectedGeo.village)) {
                setRecommendedRegionsPayload((prev: any) => ({
                    ...prev,
                    ...getPayload(geoCode),
                    metric_type: metric_type_final,
                    filters: filters_new,
                    adjacency: isChecked?.adjacency || false,
                    catchment: isChecked?.catchments && selCatchmentType ? [selCatchmentType?.title] : [],
                    ...(selectedGeo?.district && { sublevel: selectedTab }),
                }));
            }

            const res = await mapService.getMapPoiColor(payload, signal);
            const cleanedFilters = filters.map(cleanFilterTree);
            localStorage.setItem('filters', JSON.stringify(cleanedFilters));
            return res;
        },
        enabled: !isFilterLoading,
        staleTime: 50,
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (setMapColorShimmer) setMapColorShimmer(isMapColorFetching);
    }, [isMapColorFetching]);

    useEffect(() => {
        const { category, subcategory } = selCategoryList;

        if ((category.length > 0 || subcategory.length > 0) && mbpFilter && pathname === RouteConstants.root) {
            const { parent, type } = getParentGeoId(geoCode, selectedGeo, selectedTab);
            const currentPayload = {
                ...getPayload(geoCode),
                mbp_filter: JSON.parse(localStorage?.getItem("mbp-filter")!)?.data,
                parentgeoId: parent,
                adjacency: isChecked?.adjacency || false,
                ...(isChecked?.catchments && { catchment: selCatchmentType?.title }),
                // ...dynamicToggles,
            };

            // Only call API if payload has changed
            const isPayloadEqual = equal(mapPropsPayloadRef.current, currentPayload);

            if (!isPayloadEqual) {
                mapPropsPayloadRef.current = currentPayload;
                fetchMapProps(currentPayload);
            }
        }
    }, [selCategoryList, geoCode, selCurrency, mbpFilter, isChecked?.adjacency, isChecked?.subregionBoundaries, isChecked?.catchments, selCatchmentType]);

    useEffect(() => {
        setHoverData(null);
    }, [geoCode]);

    //handle map colors
    useEffect(() => {
        if (map && map.data && cifType && geoJSON) {

            districtBoundariesRef.current.forEach(polyline => polyline.setMap(null));
            districtBoundariesRef.current = [];

            // const getStyle = (feature: any) => {
            //     const geoLevel = feature?.getProperty('geoLevel');
            //     const geoId = feature?.getProperty('geoId');

            //     const fillColor = cifType.length > 0 && poiColors?.colorProperties?.length > 0 ?
            //         poiColors.colorProperties.find(item => item.geoId === geoId)?.color || '#FFFFFF' : '#FFFFFF';

            // if (Number(selectedGeo.district) === geoCode && selectedTab === 5 && geoLevel === 'district') {
            if (String(selectedGeo.district) === String(geoCode) && selectedTab === 5) {
                const geometries = geoJSON?.features
                    ?.filter((feature: any) => {
                        // Handle both old structure (geoLevel, geoId) and new structure (geoValue, hexGeoId)
                        const geoLevel = feature.properties.geoValue || feature.properties.geoLevel;
                        const geoId = feature.properties.hexGeoId || feature.properties.geoId;
                        return geoLevel === 'district' && geoId === geoCode;
                    })
                    ?.map((feature: any) => feature.geometry);
                const coordinateGroups = processGeoJSONGeometry(geometries);

                coordinateGroups.forEach((coords) => {
                    const boundary = new google.maps.Polyline({
                        path: Array.isArray(coords) ? coords : [coords],
                        map: map,
                        ...DISTRICT_BOUNDARY_STYLE
                    });
                    districtBoundariesRef.current.push(boundary);
                });

                coordinateGroups.forEach((coords) => {
                    const boundary = new google.maps.Polyline({
                        path: Array.isArray(coords) ? coords : [coords],
                        map: map,
                        ...DISTRICT_BOUNDARY_BG_STYLE
                    });
                    districtBoundariesRef.current.push(boundary);
                });
            }

            // const style = {
            //     fillColor: getFillColor(selectedGeo, selectedTab, geoLevel, poiColors?.colorProperties, cifType, geoId),
            //     fillOpacity: getFillOpacity(selectedGeo, selectedTab, geoLevel, isChecked?.subregionBoundaries, cifType.length),
            //     strokeColor: '000000',
            //     strokeWeight: getStrokeWeight(selectedGeo, selectedTab, geoLevel, isChecked?.subregionBoundaries),
            //     zIndex: getHoverLevel(geoLevel, selectedGeo, selectedTab) ? 5 : 1,
            //     clickable: (selectedGeo.village || (selectedGeo.sub_district && !isChecked?.subregionBoundaries)) ? false : true,
            //     hoverable: (selectedGeo.village || (selectedGeo.sub_district && !isChecked?.subregionBoundaries)) ? false : true,
            // };
            // return style;
            // };
            // map.data.setStyle(getStyle);
        }

        return () => {
            districtBoundariesRef.current.forEach(polyline => polyline.setMap(null));
            districtBoundariesRef.current = [];
        };
    }, [map, geoJSON, poiColors, cifType, selectedGeo, showMapColor, selectedTab, isChecked?.subregionBoundaries]);


    useEffect(() => {
        if (featuredStories.length > 0 && isChecked?.spotlight && !selectedGeo.district) {
            setOpenedStories(featuredStories.map((_, index) => index));
        }
    }, [featuredStories?.length, isChecked?.spotlight]);

    // Removed duplicate getBrands call - now handled by TanStack Query in LeftSideBarNew.tsx
    // The brands data is fetched once with all toggles enabled, and filtered client-side
    useEffect(() => {
        if (map) {
            const streetView = map.getStreetView();
            if (streetView.getVisible()) {
                streetView.setVisible(false);
            }
        }
    }, [map]);

    // Filter brands based on active dynamic POI toggles and category/subcategory selections
    const filteredBrands = useMemo(() => {
        if (!brands || Object.keys(brands).length === 0) return {};

        const filtered: Record<string, any[]> = {};

        Object.entries(brands).forEach(([key, value]) => {
            if (key === 'poimarker') {
                filtered[key] = value;
            } else {
                if (!dynamicPoiToggles[key]) return;
                filtered[key] = value as any[];
            }
        });

        return filtered;
    }, [brands, dynamicPoiToggles]);

    const highlightedPoIs = useMemo(() => {
        if (!selectedGeo.sub_district || filteredBrands?.poimarker?.length === 0) return [];

        return filteredBrands?.poimarker?.flatMap((brand) =>
            brand.branches.map((branch: any) => ({
                ...branch,
                isSelected: checkIsBrandSelected(branch.branchId, selBrands),
            }))
        );
    }, [filteredBrands, selBrands, selectedGeo.sub_district]);

    const otherMarkers = useMemo(() => {
        const result: Record<string, any[]> = {};
        Object.entries(filteredBrands || {}).forEach(([key, value]) => {
            if (key !== 'poimarker') result[key] = value;
        });
        return result;
    }, [filteredBrands]);


    useEffect(() => {
        focusedPoiRef.current = focusedPoi || { type: null, data: null };
    }, [focusedPoi]);

    useEffect(() => {
        if (pathname === RouteConstants.root) {
            if (poiColors?.rootProperties?.filterProperties?.isAdjusted && !isChecked?.catchments) {
                topRightToast.info(`Filters have been adjusted to match this region's data range`);
            }
            if (poiColors?.rootProperties?.metricProperties && !poiColors?.rootProperties?.metricProperties?.hasData) {
                // setError({ type: 'MapInfo', message: `We're unable to compute this normalised metric with the current data layers. Please revise your chosen data layers.` });
                topRightToast.info(
                    "We're unable to compute this normalised metric with the current data layers. Please revise your chosen data layers."
                )
            }
        }
    }, [poiColors]);

    useEffect(() => {
        if (prevIsHexAvailableRef.current !== null && prevIsHexAvailableRef.current === true && !isHexAvailable) {
            setShowHexUnavailableToast(true);
        }
        prevIsHexAvailableRef.current = isHexAvailable;
    }, [isHexAvailable]);

    useEffect(() => {
        if (choroplethMode === 'categorical') {
            setShowCategoricalToast(true);
            const t = setTimeout(() => setShowCategoricalToast(false), 2000);
            return () => clearTimeout(t);
        }
    }, [choroplethMode]);

    const handlePopupHover = (type: string, poi?: any, screenCoord?: number[], focusedPoi?: any) => {
        // Always update marker state for click detection
        isHoveredOnMarker.current = poi ? { ...isHoveredOnMarker.current, [type]: true } : { ...isHoveredOnMarker.current, [type]: false };

        // Don't show hover popup when a card is focused or region is focused
        if (focusedPoi?.type || isGeoFocusedRef.current) {
            return;
        }

        if (type === 'mbp') {
            if (!poi) setHoveredPresence(null);
            else if (poi?.unique_key !== hoveredPresence?.unique_key) setHoveredPresence({ ...poi, x: screenCoord?.[0], y: screenCoord?.[1] });
            setHoveredBrand(null);
        } else {
            // 'poi' and all other marker types
            if (!poi) setHoveredBrand(poi);
            else if (poi?.branchId !== hoveredBrand?.branchId) setHoveredBrand({ ...poi, x: screenCoord?.[0], y: screenCoord?.[1], _markerType: type });
            setHoveredPresence(null);
        }
        if (poi || focusedPoi?.type) {
            setHoverData(null);
        }
    };

    const handlePoiClick = (type: string | null, data: any, screenCoord?: number[]) => {

        // Close any open region hover card before opening presence/poi card
        if (isGeoFocusedRef.current && data?.geoLevel !== 'catchment') {
            handleCloseRegionCard();
        }

        // First clear both hover states to ensure clean slate
        setHoveredPresence(null);
        setHoveredBrand(null);

        // Build combined carousel from ALL colliding markers at the clicked location
        if (type && data && map) {
            const radius = type === 'mbp' ? 27.17 : 5;

            // Colliding MBPs
            const collidingMBPs: Array<{ type: string; data: any }> = myPresence && Array.isArray(myPresence) && myPresence.length > 0
                ? getCollidingMarkers(data, myPresence, map, radius, 'unique_key').map((m: any) => ({ type: 'mbp', data: m }))
                : [];

            // Colliding POIs
            const collidingPOIs: Array<{ type: string; data: any }> = isChecked?.poimarker && highlightedPoIs && Array.isArray(highlightedPoIs) && highlightedPoIs.length > 0
                ? getCollidingMarkers(data, highlightedPoIs, map, radius, 'branchId').map((p: any) => ({ type: 'poi', data: p }))
                : [];

            // Colliding custom marker types
            const collidingCustom: Array<{ type: string; data: any }> = [];
            Object.entries(otherMarkers).forEach(([markerType, markerData]) => {
                const flatMarkers = flattenMarkerData((markerData as any[]) || []);
                if (flatMarkers.length > 0) {
                    getCollidingMarkers(data, flatMarkers, map, radius, 'branchId')
                        .forEach((m: any) => collidingCustom.push({ type: markerType, data: m }));
                }
            });

            const clickedItem = { type: type as string, data };
            const allCollisions = [...collidingMBPs, ...collidingPOIs, ...collidingCustom];
            const sameType = allCollisions.filter(m => m.type === type);
            const otherTypes = allCollisions.filter(m => m.type !== type);
            const allMarkers: Array<{ type: string; data: any }> = [clickedItem, ...sameType, ...otherTypes];

            if (allMarkers.length > 1) {
                const containingFeature = removeParentFeature(geoJSON, selectedGeo, selectedTab, catchment)?.features?.find((f: any) =>
                    pointInPolygon(data.longitude, data.latitude, f.geometry)
                );

                const shouldIncludeRegion = containingFeature &&
                    !(selectedGeo?.village && (
                        containingFeature.properties.geoId === (selectedGeo.village) ||
                        containingFeature.properties.hexGeoId === (selectedGeo.village)
                    ));

                const markersWithRegion = shouldIncludeRegion
                    ? [...allMarkers, { type: 'region' as const, data: containingFeature.properties }]
                    : allMarkers;
                setMarkerCarousel({ markers: markersWithRegion, currentIndex: 0 });

                const clickY = screenCoord?.[1];
                const markerLat = data.latitude;
                const markerLng = data.longitude;
                setTimeout(() => {
                    if (!map) return;
                    const mapHeight = map.getDiv()?.clientHeight ?? window.innerHeight;
                    const projPixel = latLngToPixel(map, markerLat, markerLng);
                    const markerY = projPixel?.y ?? clickY;
                    if (markerY != null && markerY > mapHeight * 0.60) {
                        prePanCenterRef.current = map.getCenter() ?? null;
                        map.panBy(0, markerY - mapHeight * 0.45);
                        google.maps.event.addListenerOnce(map, 'idle', () => {
                            if (map) onPanChange(map);
                        });
                    }
                }, 0);
            } else {
                setMarkerCarousel(null);
                if (prePanCenterRef.current && map) {
                    map.panTo(prePanCenterRef.current);
                    prePanCenterRef.current = null;
                }
            }
        }

        // Then set the clicked item as hovered so it displays
        if (type === 'mbp') {
            setTimeout(() => setHoveredPresence({ ...data, x: screenCoord?.[0], y: screenCoord?.[1] }), 0);
        } else if (type) {
            // 'poi' and all other marker types
            setTimeout(() => setHoveredBrand({ ...data, x: screenCoord?.[0], y: screenCoord?.[1], _markerType: type }), 0);
        }

        // Always set the new focused POI/presence to show close button and track focused state
        setFocusedPoi({ type, data, x: screenCoord?.[0], y: screenCoord?.[1] });
    }

    // Handle POI click from table view
    useEffect(() => {
        if (tableClickedPoi) {
            handlePoiClick('poi', tableClickedPoi);
            setTableClickedPoi?.(null);
        }
    }, [tableClickedPoi]);

    // Handle MBP click from table view
    useEffect(() => {
        if (tableClickedMbp) {
            // Table rows may not have lat/lng; look up the full marker from myPresence
            const matchedMarker = tableClickedMbp.latitude && tableClickedMbp.longitude
                ? tableClickedMbp
                : myPresence?.find((m: any) =>
                    String(m.unique_key) === String(tableClickedMbp.unique_key)
                );
            if (matchedMarker) {
                handlePoiClick('mbp', matchedMarker);
            } else {
                // No coordinates available — just highlight the row without showing the card
                setFocusedPoi({ type: 'mbp', data: tableClickedMbp });
            }
            setTableClickedMbp?.(null);
        }
    }, [tableClickedMbp]);

    const handlePoiMouseLeave = () => {
        setHoveredBrand(null);
        if (!focusedPoi || !focusedPoi.type || focusedPoi.type !== 'poi') isHoveredOnMarker.current.poi = false;
        if (!focusedPoi || !focusedPoi.type || focusedPoi.type !== 'mbp') isHoveredOnMarker.current.mbp = false;
    }

    // Geo carousel navigation handlers
    const handleGeoCarouselNext = () => {
        if (!geoCarousel || !map) return;
        const nextIndex = (geoCarousel.currentIndex + 1) % geoCarousel.features.length;
        const nextFeature = geoCarousel.features[nextIndex];
        setGeoCarousel({ ...geoCarousel, currentIndex: nextIndex });

        // Anchor popup to the first coordinate of the feature's geometry
        const geoFeature = geoJSON?.features?.find((f: any) => f.properties.geoId === nextFeature.geoId);
        if (geoFeature) {
            const [lng, lat] = getFirstCoordinate(geoFeature.geometry.coordinates);
            const pixel = latLngToPixel(map, lat, lng);
            if (pixel) {
                outOfBoundSideRef.current = checkOutOfBoundsUsingPosition(pixel, roiBoundsRef.current);
                setHoverData({ ...nextFeature, ...pixel });
                return;
            }
        }
        setHoverData((prev: any) => ({ ...nextFeature, x: prev?.x, y: prev?.y }));
    };

    const handleGeoCarouselPrev = () => {
        if (!geoCarousel || !map) return;
        const prevIndex = geoCarousel.currentIndex === 0
            ? geoCarousel.features.length - 1
            : geoCarousel.currentIndex - 1;
        const prevFeature = geoCarousel.features[prevIndex];
        setGeoCarousel({ ...geoCarousel, currentIndex: prevIndex });

        // Anchor popup to the first coordinate of the feature's geometry
        const geoFeature = geoJSON?.features?.find((f: any) => f.properties.geoId === prevFeature.geoId);
        if (geoFeature) {
            const [lng, lat] = getFirstCoordinate(geoFeature.geometry.coordinates);
            const pixel = latLngToPixel(map, lat, lng);
            if (pixel) {
                outOfBoundSideRef.current = checkOutOfBoundsUsingPosition(pixel, roiBoundsRef.current);
                setHoverData({ ...prevFeature, ...pixel });
                return;
            }
        }
        setHoverData((prev: any) => ({ ...prevFeature, x: prev?.x, y: prev?.y }));
    };

    // Shared logic: update carousel to a specific index and sync all popup states
    const goToCarouselIndex = (newIndex: number) => {
        if (!markerCarousel) return;

        const newItem = markerCarousel.markers[newIndex];
        const anchorX = hoveredPresence?.x ?? hoveredBrand?.x ?? hoverData?.x;
        const anchorY = hoveredPresence?.y ?? hoveredBrand?.y ?? hoverData?.y;

        setMarkerCarousel({ ...markerCarousel, currentIndex: newIndex });

        if (newItem.type === 'region') {
            setHoveredPresence(null);
            setHoveredBrand(null);
            isGeoFocusedRef.current = true;
            setFocusedGeo(true);
            const geoId = newItem.data.geoId ?? newItem.data.hexGeoId;
            // Look up enriched API data (EH, CTV, PoI, Population) — same source as onHoverMap
            const enrichedData = mapPropsRef.current?.properties?.find(
                (item: any) => item.geoId === geoId || item.hexGeoId === geoId
            ) ?? newItem.data;
            // Catchment region cards render via PresenceHoverCard, which requires
            // focusedPoi.type === 'mbp' to show the click card (isMbpFocused).
            // For all other regions, clear focusedPoi as before.
            if (enrichedData?.geoLevel === 'catchment') {
                setFocusedPoi({ type: 'mbp', data: enrichedData });
            } else {
                setFocusedPoi({ type: null, data: null });
            }
            if (map) {
                const regionFeature = geoJSON?.features?.find((f: any) => {
                    const fId = f.properties.hexGeoId || f.properties.geoId;
                    return fId === geoId;
                });
                if (regionFeature) {
                    const [lng, lat] = getFirstCoordinate(regionFeature.geometry.coordinates);
                    const pixel = latLngToPixel(map, lat, lng);
                    if (pixel) {
                        outOfBoundSideRef.current = checkOutOfBoundsUsingPosition(pixel, roiBoundsRef.current);
                        setHoverData({ ...enrichedData, ...pixel });
                        return;
                    }
                }
            }
            setHoverData({ ...enrichedData, x: anchorX, y: anchorY });
        } else if (newItem.type === 'mbp') {
            setHoveredPresence({ ...newItem.data, x: anchorX, y: anchorY });
            setHoveredBrand(null);
            setFocusedPoi({ type: 'mbp', data: newItem.data });
            isGeoFocusedRef.current = false;
            setHoverData(null);
        } else {
            setHoveredBrand({ ...newItem.data, x: anchorX, y: anchorY, _markerType: newItem.type });
            setHoveredPresence(null);
            setFocusedPoi({ type: newItem.type, data: newItem.data });
            isGeoFocusedRef.current = false;
            setHoverData(null);
        }
    };

    // Combined carousel navigation — switches popup type when crossing MBP ↔ POI ↔ region boundary
    const navigateCarousel = (direction: 'next' | 'prev') => {
        if (!markerCarousel) return;
        const total = markerCarousel.markers.length;
        const newIndex = direction === 'next'
            ? (markerCarousel.currentIndex + 1) % total
            : markerCarousel.currentIndex === 0 ? total - 1 : markerCarousel.currentIndex - 1;
        goToCarouselIndex(newIndex);
    };

    // Table row click — find the clicked marker in the carousel and navigate to it
    const handleTableRowSelect = (marker: { type: string; data: any }) => {
        if (!markerCarousel) return;
        const index = markerCarousel.markers.findIndex(m => {
            if (m.type !== marker.type) return false;
            if (m.type === 'mbp')    return m.data.unique_key === marker.data.unique_key;
            if (m.type === 'region') return m.data.geoId      === marker.data.geoId;
            // poi and all custom marker types use branchId
            return m.data.branchId === marker.data.branchId;
        });
        if (index !== -1) goToCarouselIndex(index);
    };

    const handleCarouselNext = () => navigateCarousel('next');
    const handleCarouselPrev = () => navigateCarousel('prev');

    // Expose carousel handlers to the parent (Home.tsx) so CollisionTablePanel can call them
    useEffect(() => {
        if (!carouselHandlersRef) return;
        carouselHandlersRef.current.onMarkerSelect = handleTableRowSelect;
        carouselHandlersRef.current.onClose = () => {
            setMarkerCarousel(null);
            setFocusedPoi({ type: null, data: null });
            if (prePanCenterRef.current && map) {
                map.panTo(prePanCenterRef.current);
                prePanCenterRef.current = null;
            }
        };
    });

    const handlePoiClose = (e: any) => {
        e.stopPropagation();
        if (focusedPoi) {
            if (focusedPoi?.data?.geoLevel === 'catchment') {
                setHoverData(null);
                isGeoFocusedRef.current = false;
            }
            setFocusedPoi({ type: null, data: null });
            setHoveredPresence(null);
            setHoveredBrand(null);
            isHoveredOnMarker.current.mbp = false;
            isHoveredOnMarker.current.poi = false;
            // Clear unified carousel when closing popup
            setMarkerCarousel(null);
            if (prePanCenterRef.current && map) {
                map.panTo(prePanCenterRef.current);
                prePanCenterRef.current = null;
            }
            if (map) {
                google.maps.event.addListenerOnce(map, 'idle', () => onPanChange(map));
            }

        }
    }

    const handleChangeTab = (val: number) => {
        setSelectedTab(val);
        localStorage.setItem("selectedTab", JSON.stringify(val));
    }

    const renderToggleTabs = () => { return selectedGeo.district && !selectedGeo?.sub_district && pathname === RouteConstants.root && !isStreetViewEnabled }

    return (
        <>
            {/* DEBUG: pan trigger zone */}
            {/* <div style={{
                position: 'absolute', bottom: 0, left: 0, right: 0,
                height: '43%', zIndex: 9999, pointerEvents: 'none',
                background: 'rgba(255, 0, 0, 0.15)',
                border: '2px dashed red',
                boxSizing: 'border-box',
            }} /> */}

            <div
                className={mapType === 'dark' ? 'dark-zoom-controls' : ''}
                style={{ height: '100%', width: '100%', position: 'relative', overflow: 'hidden' }}
                onMouseLeave={() => {
                    // setHoverData(null);
                    // isGeoFocusedRef.current = false;
                    // setHoveredBrand(null);
                    // setHoveredPresence(null);
                    // setFocusedPoi({ type: null, data: null });
                    // isHoveredOnMarker.current.mbp = false;
                    // isHoveredOnMarker.current.poi = false;
                }}
            >
                { /* To be rectified  */}            {(false) ?
                    <SpinnerLite /> :
                    <MapLayout
                        // style={{ opacity: spinner.spinners.length === 0 && (spinnerLite > 0 || shimmerLite.includes('getBrands')) ? "0.3" : 1 }}
                        colorScheme={selectedGeo.sub_district && mapType == "dark" ? "DARK" : "LIGHT"}
                        mapTypeId={selectedGeo.sub_district && mapType === 'hybrid' ? 'hybrid' : 'roadmap'}
                        mapId={(mapType === 'map' && selectedGeo.sub_district) ? MAP_TYPE_ID : selectedGeo.state ? SILVER_MAP_ID : COUNTRY_MAP_ID}
                        gestureHandling={pathname === RouteConstants.root && selectedGeo.sub_district ? 'auto' : 'none'}
                        zoomControl={selectedGeo.sub_district && pathname === RouteConstants.root}
                        streetViewControl={!!selectedGeo.sub_district && pathname === RouteConstants.root}
                        defaultCenter={center}
                    >
                        {/***** Interactive Overlays Slot *****/}
                        <MapLayout.Overlays>
                            {map && (
                                <DeckGLOverlay
                                    key={geoCode}
                                    geoCode={geoCode || 0}
                                    showPoi={(selectedGeo.sub_district || selectedGeo.village) && isChecked?.poimarker}
                                    showMbp={isChecked?.MBP && myPresence && myPresence?.length > 0 && (pathname === RouteConstants.root || pathname === RouteConstants.dashboard)}
                                    showStories={(pathname === RouteConstants.stories || pathname === RouteConstants.story_details) && uniqueStories?.length > 0}
                                    poi={highlightedPoIs}
                                    mbp={(geoCode == selectedGeo.district && selectedTab === 4) ? (myPresence ?? []).filter((poi: any) => !poi.overlap) : myPresence}
                                    stories={uniqueStories}
                                    selectedStory={selectedStory}
                                    focusedItem={focusedPoi}
                                    onHoverPoi={(type: string, poi: any, pixel?: number[]) => handlePopupHover(type, poi, pixel, focusedPoi)}
                                    handleClick={(type: string | null, data: any, pixel?: number[]) => handlePoiClick(type, data, pixel)}
                                    brand={hoveredBrand}
                                    presence={hoveredPresence}
                                    geoJSON={geoJSON}
                                    onMapHover={onMouseOver}
                                    onMapClick={onGeoClick}
                                    isGeoFocused={isGeoFocusedRef.current}
                                    mapProps={mapProps}
                                    otherMarkers={otherMarkers}
                                    mapZoom={mapZoom}
                                />
                            )}
                        </MapLayout.Overlays>

                        {/***** Map Controls Slot *****/}
                        <MapLayout.Controls>
                            {selectedGeo.sub_district && (pathname === RouteConstants.root || pathname === RouteConstants.dashboard) && !isStreetViewEnabled && (
                                <ResetZoomButton
                                    onClick={() => {
                                        if (!map || !geoJSON?.features?.length) return;
                                        const bounds = new window.google.maps.LatLngBounds();
                                        const processCoords = (coords: any): void => {
                                            if (Array.isArray(coords[0])) coords.forEach(processCoords);
                                            else bounds.extend(new window.google.maps.LatLng(coords[1], coords[0]));
                                        };
                                        geoJSON.features.forEach((f: any) => {
                                            if (!f.properties?.is_adjacent) processCoords(f.geometry.coordinates);
                                        });
                                        if (!bounds.isEmpty()) handleResetBound(map, bounds, 20);
                                    }}
                                    onCloseRegionCard={handleCloseRegionCard}
                                />
                            )}

                            {selectedGeo.sub_district && pathname === RouteConstants.root && !isStreetViewEnabled &&
                                <MapLayers
                                    handleMapType={handleMapType}
                                    handleCloseRegionCard={handleCloseRegionCard}
                                    mapType={mapType}
                                />}

                            {pathname === RouteConstants.root && !isStreetViewEnabled &&
                                <AggUnitControl />
                            }
                        </MapLayout.Controls>

                        {/***** Popups & Info Windows Slot *****/}
                        <MapLayout.Popups>
                            {/* Featured Stories Info Windows */}
                            {isChecked?.spotlight && featuredStories?.length > 0 && !selectedGeo.district && map && (
                                <FeaturedStoriesWindows
                                    stories={featuredStories}
                                    openedStories={openedStories}
                                    focusedIndex={focused}
                                    onClose={handleCloseMapPopup}
                                    onFocus={handleFocused}
                                />
                            )}

                            {/* Geo Hover Card */}
                            {map && (
                                <GeoHoverCard
                                    hoverData={hoverData}
                                    outOfBounds={outOfBoundSideRef.current}
                                    isGeoFocused={isGeoFocusedRef.current}
                                    companyName={loggedUser.company_name}
                                    focusedPoi={focusedPoi}
                                    mbpRoi={mbpBoundRef.current}
                                    onCloseRegion={handleCloseRegionCard}
                                    onCloseCatchment={handlePoiClose}
                                    onNavigate={handleNavigation}
                                    onNavigateFromRegion={handleNavigationFromRegionCard}
                                    isCatchmentOn={isChecked?.catchments}
                                    carousel={
                                        markerCarousel && markerCarousel.markers[markerCarousel.currentIndex]?.type === 'region'
                                            ? { features: markerCarousel.markers.map(m => m.data), currentIndex: markerCarousel.currentIndex }
                                            : geoCarousel
                                    }
                                    onCarouselNext={
                                        markerCarousel && markerCarousel.markers[markerCarousel.currentIndex]?.type === 'region'
                                            ? handleCarouselNext
                                            : handleGeoCarouselNext
                                    }
                                    onCarouselPrev={
                                        markerCarousel && markerCarousel.markers[markerCarousel.currentIndex]?.type === 'region'
                                            ? handleCarouselPrev
                                            : handleGeoCarouselPrev
                                    }
                                />
                            )}

                            {/* MBP Hover Popup */}
                            {pathname === RouteConstants.root && selectedGeo?.state && hoveredPresence?.geoLevel !== 'catchment' && (
                                <MBPHoverPopup
                                    presence={hoveredPresence}
                                    companyName={loggedUser.company_name}
                                    focusedPoi={focusedPoi}
                                    roi={mbpBoundRef.current}
                                    onClose={handlePoiClose}
                                    onNavigate={handleNavigation}
                                    carousel={markerCarousel && markerCarousel.markers[markerCarousel.currentIndex]?.type === 'mbp' ? {
                                        type: 'mbp' as const,
                                        markers: markerCarousel.markers.map(m => m.data),
                                        currentIndex: markerCarousel.currentIndex,
                                        uniqueKeyField: 'unique_key',
                                    } : null}
                                    onCarouselNext={handleCarouselNext}
                                    onCarouselPrev={handleCarouselPrev}
                                />
                            )}

                            {/* POI Hover Popup */}
                            {pathname === RouteConstants.root && (
                                <POIHoverPopup
                                    brand={hoveredBrand}
                                    selectedBrands={selBrands}
                                    focusedPoi={focusedPoi}
                                    roi={poiBoundRef.current}
                                    onClose={handlePoiClose}
                                    onNavigate={handleNavigation}
                                    carousel={(() => {
                                        const currentType = markerCarousel?.markers[markerCarousel.currentIndex]?.type;
                                        if (markerCarousel && currentType && currentType !== 'mbp' && currentType !== 'region') {
                                            return {
                                                type: currentType,
                                                markers: markerCarousel.markers.map(m => m.data),
                                                currentIndex: markerCarousel.currentIndex,
                                                uniqueKeyField: 'branchId',
                                            };
                                        }
                                        return null;
                                    })()}
                                    onCarouselNext={handleCarouselNext}
                                    onCarouselPrev={handleCarouselPrev}
                                />
                            )}
                        </MapLayout.Popups>

                        {/***** Notifications Slot *****/}
                        <MapLayout.Notifications>
                            {showHelperText && (
                                <MapHelperNotification
                                    message="You can choose only one between PoI and CTV as your base visualisation"
                                    onClose={() => setShowHelperText && setShowHelperText(false)}
                                />
                            )}
                        </MapLayout.Notifications>
                    </MapLayout>}

                {/***** show table button - stays outside map *****/}

                {/***** show table button *****/}
                {pathname === RouteConstants.root &&
                    <Button
                        theme={ButtonTheme.secondary}
                        variant={ButtonVariant.bordered}
                        type='button'
                        classname='show-table-view-btn'
                        onClick={() => setOpen(!open)}
                    >
                        <span className="d-flex flex-row align-items-center">
                            Show Table View {<LuArrowUpRight />}
                        </span>
                    </Button>}

                {/***** Categorical Mode Toast *****/}
                {/* {showCategoricalToast && (
                    <div style={{
                        position: 'absolute', top: 20, right: 20, zIndex: 10000,
                        background: '#fff', borderRadius: 10,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                        padding: '10px 14px',
                        display: 'flex', alignItems: 'flex-start', gap: 10,
                        maxWidth: 280,
                        animation: 'slideIn 0.3s ease-out',
                    }}>
                        <span className="material-symbols-outlined text-muted-foreground" style={{ fontSize: 18, marginTop: 1, flexShrink: 0 }}>info</span>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1 }}>
                            <span style={{ fontSize: 13, fontWeight: 600, color: '#1f2937', lineHeight: 1.3 }}>Categorical Choropleth Mode Activated</span>
                            <span style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.4 }}>Numerical layers are now disabled since they cannot be viewed in Categorical mode.</span>
                        </div>
                        <span
                            className="material-symbols-outlined"
                            style={{ fontSize: 16, color: '#9ca3af', cursor: 'pointer', flexShrink: 0, marginTop: 1 }}
                            onClick={() => setShowCategoricalToast(false)}
                        >close</span>
                    </div>
                )} */}

                {/***** Hex Loading Toast *****/}
                {showHexToast && pathname === RouteConstants.root && (
                    <HexLoadingToast
                        progress={hexLoading.progress}
                        isAdjacency={!!isChecked?.adjacency}
                        onClose={() => setShowHexToast(false)}
                    />
                )}

                {showHexUnavailableToast && (
                    <HexUnavailableToast
                        onClose={() => setShowHexUnavailableToast(false)}
                        text={"Aggregation Unit has been updated for data availability."}
                    />
                )}
            </div>
        </>
    )
}